import { IdentityClientSettings } from "@gsgroup/gsgroup-react-ui";
import { buildHttpHeaders } from "../utils/buildHttpHeaders";

const PATH = 'identity-client-settings'

export async function getIdentityClientSettingsAsync() {

    try {
        const response = await fetch(`/${PATH}`);

        if (response.status !== 200) {
            throw new Error(await response.text());
        }
        
        const clientSettings: IdentityClientSettings = await response.json();

        return clientSettings;
    } catch (error) {
        console.log(error);

        throw error;
    }
}

export async function getHandymanSettingAsync(setting: string, accessToken: string, backendHeader: string, signal?: AbortSignal) {
    const url = `settings/${setting}`;
    try {
        const response = await fetch(url, {
            headers: buildHttpHeaders(accessToken, backendHeader),
            signal
        });

        if (response.status !== 200) {
            throw new Error(await response.text());
        }

        const result = await response.text();

        return result;
    } catch (error) {
        console.log(error);

        throw error;
    }
}